<template>
  <div class="recove_wrap">
    <van-nav-bar
      title="Recuperar o saldo"
      left-text=""
      left-arrow
      :fixed="true"
      @click-left="$router.go(-1)"
    />
    <div class="top_info_box">
      <div class="top_info flex justify-between align-center">
        <div class="flex align-center">
          <div>Saldo atual</div>
          <span>0,00</span>
          <img
            src="../../assets/images/person/refresh.png"
            alt=""
          >
        </div>
        <div class="btn">
          Um click para recuperar
        </div>
      </div>
      <div class="tip">
        Você só pode recuperar o múltiplo inteiro do equilíbrio (ou seja, sem ponto decimal)
      </div>
    </div>
    <div class="bottom_list_box flex">
      <div class="left_box">
        <div
          v-for="item in leftMenu"
          :key="item.key"
          :class="`menu_item flex align-center ${active === item.key ? 'active' : ''}`"
          @click="changeTab(item.key)"
        >
          <div
            class="icon_box"
          >
            <div
              class="icon"
              :style="{mask: `url(${item.icon}) center center no-repeat`, width: `${item.size}px`, height: `${item.size}px`}"
            />
          </div>
          <div>{{ item.title }}</div>
        </div>
      </div>
      <div class="right_box">
        <div
          v-if="active === 1"
          class="search-wrap"
        >
          <input
            v-model="searchVal"
            class="input-keyword"
            type="text"
            placeholder="Pesquisa de plataforma"
          >
          <div
            v-if="searchVal" 
            class="close_img"
            @click="searchVal = ''"
          >
            <van-icon name="cross" />
          </div>
          <van-icon
            name="search"
            class="simg"
          />
        </div>
        <div class="right_list_box">
          <div class="empty">
            <img
              src="../../assets/images/recoveBalance/empty.png"
              alt=""
            >
            <p>Sem dados disponíveis</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NavBar } from "vant";
Vue.use(NavBar);
import m1 from '../../assets/images/recoveBalance/icon_balance_all_type.svg'
import m2 from '../../assets/images/recoveBalance/777.svg'
export default {
    data() {
        return {
            active: 1,
            leftMenu: [
                {
                    title: 'Tudos',
                    icon: m1,
                    key: 1,
                    size: 20
                },
                {
                    title: 'Slots',
                    icon: m2,
                    key: 2,
                    size: 24
                }
            ],
            searchVal: ''
        }
    },
    methods: {
        changeTab(key) {
            this.active = key
        }
    }
}
</script>
<style scoped lang="less">

@import "../../assets/css/variables.less";
/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}
.flex {
    display: flex;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.recove_wrap {
    height: 100vh;
    background-color: @activityColor;
    padding-top: 45px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .top_info_box {
        margin: 10px;
        padding: 10px;
        background-color: @primary-color;
        border-radius: 10px;
        color: @textcolor5;
        span {
            color: @textcolor4;
            margin: 0 4px;
        }
        img {
            width: 14px;
            height: 14px;
        }
        .btn {
            width: 48px;
            height: 23px;
            text-align: center;
            color: @activityColor;
            background-color: @ButtonColor;
            border-radius: 6px;
            font-size: 9px;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            padding: 2px 6px 0;
            word-break: break-all;

        }
        .tip {
            text-align: right;
            font-size: 10px;
            margin-top: 6px;
        }
    }
    .bottom_list_box{
        flex: 1;
        padding: 0 10px;
        .left_box{
            margin-left: 10px;
        }
        .menu_item {
            width: 75px;
            height: 35px;
            background-color: @primary-color;
            border-radius: 5px;
            color: @textcolor5;
            margin-bottom: 8px;
            font-size: 9px;
            transition: all 0.2s;
            .icon_box{
                width: 40px;
                display: flex;
                justify-content: center;
                .icon {
                    background-color: @textcolor5;
                    mask-size: contain !important;
                }
            }
            &.active {
                background-color: @ButtonColor;
                color: @activityColor;
                .icon {
                    background-color: @activityColor;
                }
            }
        }
        .right_box {
            width: 100%;
            margin-left: 20px;
            margin-top: 6px;
            display: flex;
            flex-direction: column;
            .search-wrap {
                border: 1.5px solid @bodercolor2;
                height: 27px;
                width: 100%;
                border-radius: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 2px;
                box-sizing: border-box;
                transition: all 0.2s;
                &:focus-within {
                    border-color: @ButtonColor;
                }
                .close_img {
                    width: 16px;
                    height: 16px;
                    background-color: @textcolor5;
                    color: @textcolorf;
                    font-size: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    margin-right: 4px;
                }
                .input-keyword {
                    flex: 1;
                    height: 100%;
                    color: #fff;
                    font-size: 11px;
                    float: left;
                    text-indent: 10px;
                    background: none;
                    border: none;
                    padding-right: 10px;
                    padding-left: 4px;

                    input {
                        background: none;
                        border: none;
                        outline: none;
                    }
                }

                .input-keyword::placeholder {
                    color: @textcolor2
                }
                .simg {
                    font-size: 0.4rem;
                    margin-right: 0.2rem;
                    color: @textcolor1;
                }
            }
            .right_list_box {
                flex: 1;
                overflow-y: auto;
                .empty {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    color: @textcolor5;
                    margin-top: 60px;
                    font-size: 11px;
                    img {
                        width: 105px;
                        height: 105px;
                    }
                }
            }
        }
        
    }
}
</style>